export default __webpack_public_path__ + "static/media/aarons-logo.3e7e0f65.svg";